import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface WhatsAppContextValue {
  message: string;
  setMessage: (message: string) => void;
  resetMessage: () => void;
}

const DEFAULT_MESSAGE = 'Hola, me interesa conocer más sobre Reconócete';

const WhatsAppContext = createContext<WhatsAppContextValue | undefined>(undefined);

export function WhatsAppProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState(DEFAULT_MESSAGE);

  const resetMessage = () => setMessage(DEFAULT_MESSAGE);

  return (
    <WhatsAppContext.Provider value={{ message, setMessage, resetMessage }}>
      {children}
    </WhatsAppContext.Provider>
  );
}

export function useWhatsAppMessage() {
  const context = useContext(WhatsAppContext);
  if (!context) {
    throw new Error('useWhatsAppMessage must be used within WhatsAppProvider');
  }
  return context;
}
